import { Button, Card, Select, Space, Row, Col } from "antd";
import React, { useState, useEffect } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { BiMessageRounded } from "react-icons/bi";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

function Texts({ companyName, messages, collectionName }) {
  const [user] = useAuthState(auth);

  const mainHeaderButtons = (
    <Space wrap>
      <Button
        className="headerButtons"
        size="small"
        icon={<DownloadOutlined />}
      >
        Download Texts
      </Button>
    </Space>
  );

  const mainHeaderTitleAndSelect = (
    <Space wrap>
      <p style={{ color: "var(--dark-text)", fontSize: 16, fontWeight: 400 }}>
        Texts
      </p>
      <Select
        placeholder="Mesiah Robinson (405) 693-2122"
        style={{ minWidth: 250, marginLeft: 10 }}
      />
    </Space>
  );

  const [message, setMessage] = useState("");
  const [sentMessages, setSentMessages] = useState([]);

  useEffect(() => {
    if (messages && user) {
      const filteredMessages = messages.filter(
        (msg) => msg.sender_id === user.uid
      );
      setSentMessages(filteredMessages);
    }
  }, [messages, user]);
  const { id } = useParams();
  let today = new Date();

  let date =
    today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear();
  let time = today.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  
  const sendMessage = async () => {
    if (message !== "") {
      // Add the message to the state
      setSentMessages([
        ...sentMessages,
        { message: message, date: date, time: time },
      ]);

      // Construct the message data
      const messageData = {
        sender_id: user.uid, // Replace with the actual sender ID
        receiver_id: id,
        message: message,
        dateTime: new Date(),
      };

      try {
        const docRef = doc(db, "companies", companyName, collectionName, id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // Append new message to the existing messages array
          const existingMessages = docSnap.data().messages || [];
          const updatedMessages = [...existingMessages, messageData];

          // Update the messages in Firestore
          await updateDoc(docRef, { messages: updatedMessages });

          console.log("Message added successfully");
        } else {
          console.log("Document does not exist");
        }
      } catch (error) {
        console.log("error", error);
      }
      // Clear the input
      setMessage("");
    }
  };

  const firebaseTimestampToDate = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "Invalid Date";

    return new Date(timestamp.seconds * 1000).toLocaleString("en-US", {
      dateStyle: "short",
      timeStyle: "short",
    });
  };

  return (
    <>
      <Card
        title={mainHeaderTitleAndSelect}
        bordered={false}
        extra={mainHeaderButtons}
      >
        <Row className="message-details" gutter={[0, 16]}>
          <Col span={24} className="message-container">
            <div className="recieved-message-container">
              <span className="message">{"Hello 👋 "}</span>
              <span className="date silver-text">
                Recieved on {"date"} at {"time"}
              </span>
            </div>
            {sentMessages?.map((message, index) => {
              return (
                <div className="sent-message-container" key={index}>
                  <span className="message active-user">
                    {message?.message}
                  </span>
                  <span className="date silver-text">
                    Sent on {firebaseTimestampToDate(message?.dateTime)}
                  </span>
                </div>
              );
            }, [])}
          </Col>
          <Col span={24}>
            <TextArea
              showCount
              maxLength={300}
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Col>
          <Col span={24}>
            <button onClick={() => sendMessage()} className="send-button">
              <BiMessageRounded size={18} /> <span>Send Text</span>
            </button>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default Texts;
